var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { round } from 'helpers/Utils';
export class TicketPayment {
    constructor(paymentMethod) {
        this._amount = 0;
        this.receipt = null;
        this.setMethod = (method) => {
            this._method = method;
        };
        this.setAmount = (amount) => {
            this._amount = round(amount);
            // this.setMethod(this.method)
        };
        this.setAfiliate = (afiliate) => {
            this._afiliate = afiliate;
        };
        this._method = paymentMethod;
    }
    get afiliate() {
        return this._afiliate;
    }
    get method() {
        return this._method;
    }
    get amount() {
        return this._amount;
    }
    get log() {
        return this._log;
    }
    set log(value) {
        this._log = value;
    }
    set user(value) {
        this._user = value;
    }
    set user_id(value) {
        this._user_id = value;
    }
    set terminal(value) {
        this._terminal = value;
    }
    toJSON() {
        const log = {
            user: this._user,
            user_id: this._user_id,
            terminal: this._terminal,
            date: new Date().toISOString()
        };
        return {
            method: this._method,
            amount: this._amount,
            receipt: this.receipt,
            afiliate_id: this._afiliate ? this.afiliate.id : null,
            afiliateName: this._afiliate ? this.afiliate.name : null,
            afiliateTypeCommission: this._afiliate ? this.afiliate.typeCommission : null,
            afiliateCommission: this._afiliate ? this.afiliate.commission : null,
            log
        };
    }
}
__decorate([
    observable
], TicketPayment.prototype, "_method", void 0);
__decorate([
    observable
], TicketPayment.prototype, "_amount", void 0);
__decorate([
    observable
], TicketPayment.prototype, "_afiliate", void 0);
__decorate([
    action
], TicketPayment.prototype, "setMethod", void 0);
__decorate([
    action
], TicketPayment.prototype, "setAmount", void 0);
__decorate([
    action
], TicketPayment.prototype, "setAfiliate", void 0);
export const PaymentMethod = {
    Due: 'due',
    Cash: 'cash',
    Card: 'card',
    Credit: 'credit',
    Transfer: 'transfer',
    Other: 'other',
    Mixed: 'mixed'
};



//////////////////
// WEBPACK FOOTER
// ./src/Models/TicketPayment.ts
// module id = 30
// module chunks = 0